// COMPLETE UPDATED FILE
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { checkAuth as checkAuthApi } from "../api/auth";

// Restores the current session (if any) using the existing HTTP-only
// `access_token` cookie. This is dispatched once when the app boots so the
// user doesn't unexpectedly appear logged out after a refresh.
export const checkAuth = createAsyncThunk("auth/checkAuth", async (_, { rejectWithValue }) => {
        try {
                const response = await checkAuthApi();
                const user = response.data.user;
                // Normalize to the same shape the rest of the app already expects
                // from `state.auth.user` (see Login.js) - notably `id` instead of
                // Mongo's `_id`, and no password field.
                return {
                        id: user._id,
                        name: user.name,
                        email: user.email,
                        profileImageUrl: user.profileImageUrl,
                        handle: user.handle,
                        bio: user.bio,
                        bannerUrl: user.bannerUrl,
                };
        } catch (error) {
                return rejectWithValue(null);
        }
});

const initialState = {
        user: {},
        isLoggedIn: false,
        error: null,
        // Whether the initial "am I already logged in?" check has finished.
        // The navbar uses this to avoid flashing the logged-out UI before
        // the real auth state is known.
        authChecked: false,
}

const authSlice = createSlice({
        name: "auth",
        initialState,
        reducers: {
                login: (state, action) => {
                        state.user = action.payload;
                        state.isLoggedIn = true;
                        state.authChecked = true;
                },
                logout: (state) => {
                        state.user = {};
                        state.isLoggedIn = false;
                        state.authChecked = true;
                },
                // Lets Settings.js patch the current user's profile fields in the
                // store right after a successful save, without a full re-fetch.
                updateProfile: (state, action) => {
                        state.user = { ...state.user, ...action.payload };
                },
        },
        extraReducers: (builder) => {
                builder
                        .addCase(checkAuth.fulfilled, (state, action) => {
                                state.user = action.payload;
                                state.isLoggedIn = true;
                                state.authChecked = true;
                        })
                        .addCase(checkAuth.rejected, (state) => {
                                // No valid session (or the check failed) - continue as guest.
                                state.user = {};
                                state.isLoggedIn = false;
                                state.authChecked = true;
                        });
        },
});

export const { login, logout, updateProfile } = authSlice.actions;

export default authSlice.reducer;